import axios from "axios";
import { toast } from "react-toastify";

axios.defaults.withCredentials = true;

const axiosApiInstance = axios.create({
  baseURL: "",
  headers: {
    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
  },
});

axiosApiInstance.interceptors.request.use(
  (config) => {
    const token = window.sessionStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Basic ${token}`;
    }
    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    } else {
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosApiInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if ([401].includes(error.response.status)) {
      toast.error("Unauthorized Access...");
      setTimeout(() => {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/";
        window.location.reload();
      }, 2000);
    }
    return Promise.reject(error);
  }
);

export default axiosApiInstance;
